import { filterFactory } from './filterFactory'
import { pluralize, splitWords, zeroFill } from '@/services/utility/string.utility.js'
import { toCurrency } from '@/services/utility/currency.utility.js'

export const pluralizeFilter = filterFactory('pluralize', pluralize)
export const splitWordsFilter = filterFactory('splitWords', splitWords)
export const toCurrencyFilter = filterFactory('toCurrency', toCurrency)
export const zeroFillFilter = filterFactory('zeroFill', zeroFill)
